
export const UserDataAction = (data) => {
	return{
	  type: "USER_DATA",
	  payload: { data}
	}
}